import { useForm } from "react-hook-form";
import CustomButton from "components/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import http from "../../../http";
import { apiUrl } from "config/settings";
import { useEffect, useState } from "react";
import ClientItems from "./ClientItems";
import ClientDetails from "./ClientDetails";
import SelectInput from "components/files/SelectInput";
import { DateTimePicker } from "@mui/x-date-pickers";
import moment from "moment/moment";
import useDataManager from "hooks/useDataManager";
import { setList, setOpenCreateServices } from "store/servicesCallSlice";
import { setShowLoading } from "store/sysSlice";
import NullCheck from "components/NullCheck";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { Divider, Stack, Typography, } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import Media from "./Media";
import { endpointName } from "../const";
import useForms from "hooks/useForms";

const CreateServices = () => {
  const { formData } = useForms();
  const { addItem } = useDataManager();
  const dispatch = useDispatch();
  const { bt } = useBizTypeTranslation();
  const { handleSubmit, reset, control, watch, clearErrors, setValue, formState: { errors } } = useForm();
  const open = useSelector((state) => state?.servicesCall.openCreateServices);
  const employees = useSelector((state) => state?.employees?.list);
  const biz = useSelector((state) => state?.biz?.data);
  const clients = useSelector((state) => state?.clients?.list);
  const departments = useSelector((state) => state?.departments?.list);
  const list = useSelector((state) => state?.servicesCall.list);
  const [clientData, setClientData] = useState(null);
  const [workDt, setWorkDt] = useState(null);
  const [clientsData, setClientsData] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [employeeslist, setEmployeeslist] = useState([]);
  const [media1, setMedia1] = useState(null);
  const [media2, setMedia2] = useState(null);

  const clientId = watch("clientId");
  const departmentsId = watch("department");

  useEffect(() => {
    if (open && departments?.length > 0)
      reset({ department: departments[0]?._id })
  }, [open, departments])

  useEffect(() => {
    if (clientId) {
      const findClient = clientsData?.find((client) => client?.guid === clientId);
      setClientData(findClient);
      setValue("addr", findClient?.addr);
      setValue("name", findClient?.contactName);
      setValue("tel", findClient?.tel);
    }
  }, [clientId]);

  useEffect(() => {
    if (clients.length > 0) {
      const list = clients?.map((client) => {
        return {
          name: client?.company
            ? `${client?.company} (${client?.contactName})`
            : client?.contactName,
          id: client?.guid,
        };
      });
      setClientList(list);
      setClientsData(clients);
    }
  }, [clients]);

  useEffect(() => {
    if (departmentsId || departments?.length > 0) {
      const department = departmentsId || departments[0]
      const empDepartmentList = employees?.filter(emp => department === emp?.department)
      setEmployeeslist(empDepartmentList?.map(emp => { return { name: `${emp.fn} ${emp.ln}`, id: emp?.id } }))
      setValue('empId', null)
    }
  }, [departmentsId, departments])

  const onClose = () => {
    dispatch(setOpenCreateServices(false));
  }

  const onSubmit = async (values) => {
    try {
      if (itemList?.length === 0) return alert("יש להוסיף לפחות ציוד אחד לרשימה");

      dispatch(setShowLoading(true));

      let data = {
        isRead: true,
        employeeId: values?.empId,
        clientId: values.clientId ?? "",
        color: values.color,
        clienCompany: clientData?.company,
        contentWithItems: itemList,
        workDt: workDt,
        ...values,
      };

      const res = await http.post(`${apiUrl}/${endpointName}`, data)
      let mediaList = []

      if (media1) {
        const resMedia = await http.post(`${apiUrl}/${endpointName}/media/${res?.data?.callId}`, formData({ file: media1 }))
        mediaList.push(resMedia?.data?.media)
      }

      if (media2) {
        const resMedia = await http.post(`${apiUrl}/${endpointName}/media/${res?.data?.callId}`, formData({ file: media2 }))
        mediaList.push(resMedia?.data?.media)
      }

      data._id = res?.data?.itemId;
      data.callId = res?.data?.callId;
      data.employee = values?.empId;
      data.pmtTypeId = 1;
      data.stTypeId = 1;
      data.price = 0;
      data.created = moment();
      data.media = mediaList;

      const newList = addItem(data, list);
      dispatch(setList(newList));
      dispatch(setShowLoading(false));
      dispatch(setOpenCreateServices(false));
    }
    catch (error) {
      dispatch(setShowLoading(false));
      dispatch(setOpenCreateServices(false));
    }
  };

  return (
    <CustomDialog
      open={open}
      minWidth={500}
      onClose={onClose}
      title='CREATE_SERVICES'
      closeBtn='CLOSE'
      actionBtn={{ title: "SAVE", onClick: () => handleSubmit(onSubmit)() }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack gap={2} justifyContent="center">
          <Stack spacing={2}>

            <Stack spacing={2} direction={"row"} >
              <NullCheck valueForCheck={departments?.length > 1}>
                <SelectInput
                  width="100%"
                  name="department"
                  title="SELECT_DEPARTMENTS"
                  addFlex
                  errors={errors}
                  control={control}
                  required
                  options={departments?.map((dep) => {
                    return { name: dep?.name, id: dep?._id };
                  })}
                />
              </NullCheck>

              <NullCheck valueForCheck={departmentsId}>
                <SelectInput
                  width="100%"
                  name="empId"
                  addFlex
                  title="SELECT_EMP"
                  control={control}
                  errors={errors}
                  required
                  disabled={employeeslist?.length === 0}
                  options={employeeslist}
                />
              </NullCheck>
            </Stack>

            <Stack>
              <Typography fontSize={12}>{bt("WORK_DT")}:</Typography>
              <Stack width='100%' direction='row' spacing={1}>
                <DateTimePicker
                  sx={{ width: '100%' }}
                  // minDate={moment()}
                  value={workDt}
                  onChange={(e) => setWorkDt(e)}
                />
                <CustomButton title='INSTANT' onClick={() => setWorkDt(moment())} />
              </Stack>
            </Stack>

            <Divider />


            <ClientDetails
              clientList={clientList}
              control={control}
              errors={errors}
            />

            <ClientItems
              clientId={clientId}
              itemList={itemList}
              control={control}
              errors={errors}
              setItemList={setItemList}
              clientData={clientData}
            />

            <NullCheck valueForCheck={biz?.hasServiceMedia}>
              <Media
                setMedia1={setMedia1}
                setMedia2={setMedia2}
                clearErrors={clearErrors}
              />
            </NullCheck>

          </Stack>
        </Stack>
      </form>
    </CustomDialog>
  );
};
export default CreateServices;
